import {ConfirmationDialog} from '@primer/react'
import {useArchiveDialog} from '../contexts/ArchiveDialogContext'
import {useArchiveTask} from '../hooks/use-archive-task'

export function ArchiveConfirmationDialog() {
  const {dialogState, closeArchiveDialog, setArchiveStatus} = useArchiveDialog()
  const {mutate: archiveTask} = useArchiveTask({
    repoOwner: dialogState.repoOwner,
    repoName: dialogState.repoName,
    taskId: dialogState.taskId ?? undefined,
  })

  const handleClose = (gesture: 'confirm' | 'cancel' | 'close-button' | 'escape') => {
    if (gesture === 'confirm') {
      archiveTask(undefined, {
        onSuccess: () => {
          setArchiveStatus('success')
          closeArchiveDialog()
        },
        onError: () => {
          setArchiveStatus('error')
          closeArchiveDialog()
        },
      })
    } else {
      closeArchiveDialog()
    }
  }

  if (!dialogState.isOpen) {
    return null
  }

  return (
    <ConfirmationDialog
      onClose={handleClose}
      title="Archive session"
      confirmButtonContent="Yes, archive"
      cancelButtonContent="Cancel"
      confirmButtonType="danger"
    >
      Are you sure you want to archive this session?
    </ConfirmationDialog>
  )
}
